import React, { useState } from 'react';
import { router } from '@inertiajs/react';
import SignupLayout from '../Layout.jsx';
import RadioCard from '../../../components/RadioCard.jsx';
import { primaryBtnClass, secondaryBtnClass, saveDraftPatch } from '../shared.jsx';

function HourPill({ dotClass, children }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-2.5 py-0.5 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-200">
      <span className={`h-1.5 w-1.5 rounded-full ${dotClass}`} />
      {children}
    </span>
  );
}

export default function IndividualRole({ role: initialRole, progress }) {
  const [role, setRole] = useState(initialRole || '');
  const [submitting, setSubmitting] = useState(false);

  const handleContinue = async () => {
    if (!role || submitting) return;
    setSubmitting(true);
    await saveDraftPatch({ flow: 'individual', individual: { role, training_type: null } });
    router.visit('/signup/individual/training');
  };

  return (
    <SignupLayout progress={progress}>
      <div className="space-y-4">
        <div className="text-center space-y-2">
          <h2 className="text-2xl/9 font-bold tracking-tight text-gray-900">What best describes your role?</h2>
          <p className="text-sm text-gray-500">This determines which state-approved courses you'll see.</p>
        </div>
        <fieldset className="space-y-3 mt-6">
          <RadioCard
            name="role" value="Administrator"
            checked={role === 'Administrator'}
            onChange={() => setRole('Administrator')}
            label="Facility Administrator"
            description="RCFE or ARF — 40-hour complete recertification"
          >
            <span className="mt-2 flex flex-wrap gap-2">
              <HourPill dotClass="bg-emerald-500">20 hrs Live</HourPill>
              <HourPill dotClass="bg-blue-500">20 hrs Self-Paced</HourPill>
            </span>
            <span className="block text-xs italic text-gray-400 mt-2">GH & STRTP coming soon</span>
          </RadioCard>
          <RadioCard
            name="role" value="Caregiver"
            checked={role === 'Caregiver'}
            onChange={() => setRole('Caregiver')}
            label="Caregiver / Direct Care Staff"
            description="Title 22 initial and required annual training"
          />
        </fieldset>

        <p className="mt-4 text-center text-xs text-gray-500">
          Not sure? Pick Administrator if you sign off on facility compliance.
        </p>

        <div className="flex gap-3 mt-4">
          <button type="button" onClick={() => router.visit('/signup/individual/buyer')} className={`${secondaryBtnClass} flex-1`}>Back</button>
          <button type="button" onClick={handleContinue} disabled={!role || submitting} className={`${primaryBtnClass} flex-1`}>Continue</button>
        </div>
      </div>
    </SignupLayout>
  );
}
